"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _userAgent = require("../../utils/userAgent");

var PrerenderReady = function PrerenderReady(_ref) {
  var ready = _ref.ready,
      statusCode = _ref.statusCode;
  var isPrerenderUserAgent = (0, _userAgent.getIsPrerenderUserAgent)();
  var prerenderReady = isPrerenderUserAgent && ready;
  (0, _react.useEffect)(function () {
    if (prerenderReady) {
      window.prerenderReady = true;
      return function () {
        window.prerenderReady = false;
      };
    }

    return function () {};
  }, [prerenderReady]);

  if (!prerenderReady) {
    return null;
  }

  return _react.default.createElement(_react.Fragment, null, statusCode && _react.default.createElement("meta", {
    name: "prerender-status-code",
    content: "" + statusCode
  }));
};

PrerenderReady.propTypes = {
  ready: _propTypes.default.bool,
  statusCode: _propTypes.default.number
};
PrerenderReady.defaultProps = {
  ready: true
};
var _default = PrerenderReady;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/prerender/PrerenderReady.js
// module id = 106
// module chunks = 209 210 211 212